import { CheckCircleIcon } from "@heroicons/react/outline";
import PropTypes from "prop-types";
import classNames from "classnames";

/* eslint-disable multiline-ternary */
const PasswordStrengthRule = ({ label, passing }) => (
	<div className={classNames("d-flex mb-1 fs-16", { "text-muted": !passing })}>
		<CheckCircleIcon className={`i i-2x me-2 ${passing ? "text-green" : "text-danger"}`} />

		{label}
	</div>
);

PasswordStrengthRule.propTypes = {
	label: PropTypes.string.isRequired,
	passing: PropTypes.bool.isRequired
};

export default PasswordStrengthRule;
